<template>
  <picture v-if="lazy" :class="desktop || tablet || mobile ? 'is-loading' : null">
    <source :data-srcset="mobile" media="(max-width: 768px)" v-if="mobile">
    <source :data-srcset="tablet" media="(max-width: 1199px)" v-if="tablet">
    <source :data-srcset="desktop" media="(min-width: 1200px)" v-if="desktop">
    <img :src="blurred || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='" class="lazyload blur-up" :data-src="desktop || tablet || mobile" v-bind="$attrs">
  </picture>
  <picture v-else>
    <source :srcset="mobile" media="(max-width: 768px)" v-if="mobile">
    <source :srcset="tablet" media="(max-width: 1199px)" v-if="tablet">
    <source :srcset="desktop" media="(min-width: 1200px)" v-if="desktop">
    <img :src="desktop || tablet || mobile" v-bind="$attrs">
  </picture>
</template>

<script>
export default {
  props: {
    desktop: {type: String, default: null},
    tablet: {type: String, default: null},
    mobile: {type: String, default: null},
    blurred: {type: String, default: null},
    lazy: {type: Boolean, default: false}
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ResponsiveImage.vue